<div class="CeInfoButton" [ngClass]="'CeInfoButton--' + size()">
    <button
        type="button"
        ce-button-small
        ce-button-type-quaternary
        ce-button-icon
        [attr.disabled]="disabled() ? '' : null"
        [attr.aria-label]="'Show additional information'"
        [ce-popover-trigger-for]="infoButtonPopover"
        [ce-popover-position]="position()"
        [cePopoverWorksOnHover]="cePopoverWorksOnHover()"
        [cePopoverCustomOverlay]="{
            enabled: cePopoverCustomOverlay().enabled,
            overlaySelector: cePopoverCustomOverlay().overlaySelector,
        }"
    >
        <ce-icon svgIcon="info" ce-icon-xs class="u-color-text-secondary" />
    </button>
    <ce-popover-overlay #infoButtonPopover>
        <ce-popover
            class="CeInfoButton-popover u-text-body-sm flex-col
            u-spacing-{{ contentPadding() }}-pa
            u-size-{{ popoverWidth() }}-w"
        >
            @if (component()) {
                <ng-container *ngComponentOutlet="component()"></ng-container>
            } @else if (text()) {
                <div [innerHTML]="text()"></div>
            }
        </ce-popover>
    </ce-popover-overlay>
</div>
